<span class="hard-skill">
  <span class="hard-skill__text">{{ skill?.name }}</span>
</span>
